import DrnTemplatesEdit from '@/components/configs/drn/templates/edit/DrnTemplatesEdit.vue'
import MessageBox from '@/components/common/messagebox/MessageBox.vue';
import { mapState } from 'vuex';

export default {
  name: 'DrnTemplatesList',
  data () {
    return {
      isMounted: false,
      loading: true,
      filterValues: [],
      items: [],
      paging: {
        page: 1,
        pages: 1,
        limit: 30,
        total: 0
      }
    }
  },
  components: {
    DrnTemplatesEdit,
    MessageBox
  },
  computed: {
    ...mapState(['config']),
    tableHeaders () {
      const headers = [
        { key: 'pdf_template_id', label: this.$t('drn-template.pdf-template'), format: 'formatFromConfig', configKey: 'pdf_templates', configParam: 'code', nolocale: true },
        { key: 'material_group_id', label: this.$t('material-group.title'), format: 'formatFromConfig', configKey: 'material_groups', configParam: 'name' },
        { key: 'date_period_id', label: this.$t('drn-template.date-period'), format: 'formatDatePeriod' },
        { key: 'template_overwrites', label: this.$t('drn-template.contract-overwrites'), format: 'formatFunc', funcs: [this.getTemplateOverwriteInfo], classFuncs: [this.getTemplateOverwriteClass] },
        { key: 'info.' + this.$i18n.locale, label: this.$t('drn-template.info.title'), format: 'formatJsonTranslations', trasnkey: 'drn-template.info.' }
      ];
      const actions = [
        { label: this.$t('menu.config.drn-templates.test'), emit: 'testItem', bicon: 'file-ppt', class: 'btn-download' }
      ];
      if (this.canEdit) {
        actions.unshift({ label: this.$t('menu.config.drn-templates.edit'), emit: 'editItem', icon: 'edit', bicon: 'pencil-fill' });
        actions.push({ label: this.$t('menu.config.drn-templates.delete'), emit: 'deleteItem', icon: 'delete', bicon: 'trash' });
      }
      headers.push({ key: 'actions', label: '', actions: actions, class: 'col-width-large' })
      return headers;
    },
    tableActions () {
      const actions = { };
      if (this.canEdit) {
        actions.add = { title: this.$t('menu.config.drn-templates.new') };
      }
      return actions;
    },
    canEdit () {
      return this.ApiRequest.userHasPermission('edit-settings');
    }
  },
  methods: {
    changePage (page, key) {
      this.paging.page = page;
      this.getTableData();
    },
    getTableData () {
      const self = this;
      this.loading = true;
      this.ApiRequest.request('drn-templates/list?perPage=' + this.paging.limit + '&page=' + this.paging.page, this.ApiRequest.REQUEST_GET, [], function (response) {
        if (response.data) {
          self.items = response.data;
          self.paging = response.paging;
        }
        self.loading = false;
      });
    },
    deleteItem (el, approved = false) {
      if (approved) {
        const self = this;
        this.ApiRequest.request('drn-templates/' + el.id + '/delete', this.ApiRequest.REQUEST_POST, [], function (response) {
          if (response.error) {
            self.ApiRequest.displayErrorDialog(response, self);
          } else {
            self.getTableData()
          }
        });
      } else {
        this.$refs.deleteElMsgBox.show(
          el,
          this.$t('menu.config.drn-templates.delete'),
          this.$t('menu.config.drn-templates.delete-message', {
            dateperiod: this.$tc('general.datePeriod.short', this.BasicHelper.datePeriodCodeToData(el.date_period_id).period, this.BasicHelper.datePeriodCodeToData(el.date_period_id)),
            material_group: this.$options.filters.formatFromConfig(el.material_group_id, this.config.material_groups, 'name', this.$i18n.locale)
          })
        );
      }
    },
    editItem (el) {
      this.$refs.editElFrm.show(el);
    },
    testItem (el) {
      this.ApiRequest.request('drn-templates/' + el.id + '/test-pdf', this.ApiRequest.REQUEST_DOWNLOAD, [], function (response) {
      });
    },
    getTemplateOverwriteClass (val, data) {
      if (parseInt(data.item.order) === 1) {
        return 'text-success font-weight-bold';
      }
      return '';
    },
    getTemplateOverwriteInfo (val, data) {
      if (parseInt(data.item.order) === 1) {
        return this.$t('drn-template.primary');
      } else if (val) {
        return val.length;
      }
      return '-'
    }
  },
  mounted () {
    this.filterValues = this.BasicHelper.fillFilterValues(this.$route.name, this.filterValues, this.$session);
    this.isMounted = true;
    this.getTableData();
  }
}
